import { GridCustomCellProps } from "@progress/kendo-react-grid";
import {
  InputPrefix,
  InputSeparator,
  InputSuffix,
  NumericTextBox,
  NumericTextBoxChangeEvent,
} from "@progress/kendo-react-inputs";

interface Props {
  startAdornment?: string;
  endAdornment?: string;
}

export const PriceCell = (props: GridCustomCellProps & Props) => {
  const { dataItem, field, onChange, endAdornment, startAdornment = "$" } = props;
  const defaultValue = field ? dataItem[field] : "";

  const handleChange = (event: NumericTextBoxChangeEvent) => {
    if (onChange) {
      onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: event.syntheticEvent,
        value: event.value,
        dataIndex: 0,
      });
    }
  };

  return (
    <td {...props.tdProps}>
      <NumericTextBox
        value={defaultValue}
        onChange={handleChange}
        spinners={false}
        prefix={() => (
          startAdornment &&
          <>
            <InputPrefix orientation="horizontal">
              <div style={{ padding: "8px" }}>$</div>
            </InputPrefix>
            <InputSeparator />
          </>
        )}
        suffix={() => (
          endAdornment &&
          <>
            <InputSeparator />
            <InputSuffix orientation="horizontal">
              <div style={{ padding: "8px" }}>{endAdornment}</div>
            </InputSuffix>
          </>
        )}
      />
    </td>
  );
};
